import { createRef, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// @bend-expect trellis-tokenized
const StyledLabel = styled.div.withConfig({
  displayName: "ButtonLabel__StyledLabel",
  componentId: "sc-1fzoy9a-0"
})(["color:", ";max-height:36px;font-size:", ";line-height:", ";overflow:hidden;text-overflow:ellipsis;white-space:normal;word-break:keep-all;", ""], ({
  disabled,
  theme
}) => disabled ? theme.color['icon-core-disabled'] : theme.color['icon-core-default'], ({
  theme
}) => theme.typography['detail-200'].fontSize, ({
  theme
}) => theme.typography['detail-200'].lineHeight, ({
  isVerticalEllipsis
}) => isVerticalEllipsis && `
      display: -webkit-box;
      word-break: break-word;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    `);
function ButtonLabel({
  disabled,
  text
}) {
  const ref = /*#__PURE__*/createRef();
  const [isVerticalEllipsis, setIsVerticalEllipsis] = useState(false);
  useLayoutEffect(() => {
    // This calculates whether the text is overflowed in y dimension, and enables
    // the ellipsis to be shown for vertical overflow with a dynamic class.
    if (ref && ref.current && ref.current.clientWidth >= ref.current.scrollWidth && ref.current.clientHeight < ref.current.scrollHeight) {
      // overflowing vertically
      setIsVerticalEllipsis(true);
    }
  }, [ref, text]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledLabel, {
      ref: ref,
      disabled: disabled || false,
      isVerticalEllipsis: isVerticalEllipsis,
      children: text
    })
  });
}
export default ButtonLabel;